<template>
  <fragment id="scroll-list">
    <fragment
      v-for="(item, index) of renderedItems"
      :key="JSON.stringify(item)"
      id="loop-for-items"
    >
      <slot
        name="list-item"
        :item="item"
        :index="index"
        :style="{ width: '100%' }"
      ></slot>
    </fragment>
    <scroll-trigger
      v-if="morePages"
      @triggerVisible="readPage"
    ></scroll-trigger>
  </fragment>
</template>

<script>
import ScrollTrigger from './ScrollTrigger'
import { Fragment } from 'vue-frag'

export default {
  name: 'scroll-list',
  components: { ScrollTrigger, Fragment },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      type: Number,
      default: () => 30,
    },
  },
  computed: {
    morePages: function () {
      return this.items.length != this.renderedItems.length
    },
  },
  data: () => ({
    renderedItems: [],
    page: 0,
    selectedItem: null,
  }),
  watch: {
    items: async function () {
      // console.log('components.scroll-list.watch.item', this.items)
      // console.log(
      //   'components.scroll-list.watch.item.page',
      //   this.page,
      //   this.renderedItems.length,
      //   this.renderedItems
      // )

      // Assert if the new list of itmes is similar to rendered list for the visible items.
      const newItems = this.newPage()

      const newStr = newItems.map((i) => JSON.stringify(i)).join('')
      const existingStr = this.renderedItems
        .map((i) => JSON.stringify(i))
        .join('')

      // console.log('new-str', newStr)
      // console.log('existing-str', existingStr)

      if (newStr != existingStr) {
        this.renderedItems.splice(0)
        this.page = 0
        // TODO unclear why but without next tick the list wont render despite the rendered items array is changed.
        await this.$nextTick()
        this.readPage()
        // console.log(
        //   'components.scroll-list.watch.re-render',
        //   this.renderedItems
        // )
      }
      // else
      // console.log(
      //   'components.scroll-list.watch.no-re-render',
      //   this.renderedItems
      // )
    },
  },
  mounted() {
    // console.log('components.scroll-list.mounted', this.items)
    this.readPage()
    // console.log(
    //   'components.scroll-list.mounted.rendered-items',
    //   this.renderedItems
    // )
  },
  methods: {
    readPage() {
      const start = this.page * this.pageSize
      const end = start + this.pageSize
      this.page++
      // this.renderedItems = this.renderedItems.concat(
      //   this.items.slice(start, end)
      // )
      this.renderedItems.push(...this.items.slice(start, end))
      // TODO the getter on rendered items need to be used to trigger a rendering.
      // This error was detected as the use of the console made the code work. When removed it stopped working.
      // this.renderedItems || true
      // this.renderedItems = [
      //   ...this.renderedItems,
      //   ...this.items.slice(start, end),
      // ]
      // console.log('readpage', Array.isArray(this.renderedItems))
      // console.log(
      //   'components.scroll-list.methods.read-page',
      //   start,
      //   end,
      //   this.page
      // )
    },
    newPage() {
      const end = (this.page + 1 - 1) * this.pageSize
      return this.items.slice(0, end)
    },
  },
}
</script>
